import {useGetRequestData} from "./client";

export const useModmailIndex = (feedbackCh, community, type) =>
    useGetRequestData(feedbackCh, `/api/v2/modmail/get.json?type=${type}&community=${community}`);

export const useModmailThread = (feedbackCh, community, id) =>
    useGetRequestData(feedbackCh, `/api/v2/modmail/thread.json?community=${community}&id=${id}`);